<template>
  <v-text-field
      :label="trans('general.tableFilterSearch')"
      append-icon="mdi-magnify"
      single-line
      hide-details
      :style="{'max-width': (width || 400) + 'px'}"
      v-bind="$attrs"
      :value="value"
      @input="updateFilterSearchText"
      clearable
  ></v-text-field>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import {debounce} from 'lodash';

export default {
  name: 'Search',
  mixins: [
      LocaleUtils
  ],
  props: ['value', 'width'],
  mounted() {
    this.updateFilterSearchText = debounce(this.updateFilterSearchText, 300);
  },
  methods: {
    updateFilterSearchText (filterSearchText) {
      this.$emit('input', filterSearchText);
    }
  }
}
</script>
